import axios from 'axios';
import config from '@/config';
import store from './../index';

const searchEndpoint = `${config.API_URL}/Search`;
const companiesEndpoint = `${config.API_URL}/Companies`;
const documentEndpoint = `${config.API_URL}/Documents`;

export const getCompanies = (_, { searchedCompany, pageSize, pageNumber }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${searchEndpoint}/Companies?pageNumber=${pageNumber}&pageSize=${pageSize}&q=${searchedCompany}`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getCompaniesExecutive = (_, { searchedCompany, pageSize, pageNumber }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${searchEndpoint}/Executives?pageNumber=${pageNumber}&pageSize=${pageSize}&q=${searchedCompany}`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getCompanyInfo = (_, { searchedCompanySiren }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${companiesEndpoint}/${searchedCompanySiren}`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getCompanyPeople = (_, { searchedCompanySiren }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${companiesEndpoint}/${searchedCompanySiren}/people`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const exportCompanyPeople = async ({ getters }, { siren }) =>
  await axios({
    url: `${companiesEndpoint}/${siren}/people/export`,
    method: 'GET',
    responseType: 'blob',
    headers: { Authorization: `Token ${getters.apikey}` },
  });

export const getCompanyMemos = (_, { searchedCompanySiren, pageNumber, pageSize }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${companiesEndpoint}/${searchedCompanySiren}/memos?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getCompanyEtablishment = (_, { searchedCompanySiren }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${companiesEndpoint}/${searchedCompanySiren}/etabs`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getCompanyDocument = (_, { searchedCompanySiren, year }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${companiesEndpoint}/${searchedCompanySiren}/initialdocuments${year ? `?year=${year}` : ``}`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getCompanyDocumentInfos = (_, { searchedCompanySiren }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${companiesEndpoint}/${searchedCompanySiren}/initialdocuments/metrics`, {
        headers: { Authorization: `Token ${store.getters.apikey}` },
      })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const getCompanyPdf = (_, { publicId }) =>
  new Promise((resolve, reject) =>
    axios
      .get(`${documentEndpoint}/${publicId}`, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const addCompanyMemo = (_, { searchedCompanySiren, memo }) =>
  new Promise((resolve, reject) =>
    axios
      .post(`${companiesEndpoint}/${searchedCompanySiren}/memos`, { memo }, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );

export const updateCompanyMemo = (_, { id, searchedCompanySiren, memo }) =>
  new Promise((resolve, reject) =>
    axios
      .put(`${companiesEndpoint}/${searchedCompanySiren}/memos/${id}`, { memo }, { headers: { Authorization: `Token ${store.getters.apikey}` } })
      .then(response => {
        const result = response.data;
        resolve(result);
      })
      .catch(err => {
        reject(err);
      }),
  );
